// v1.0 - F4/F5: TYPE_CONFIG + IMPACT_COLORS extracted from InsightsPanel (§3.3 no-hardcoding) - 2026-07-02
import React from 'react';
import {
  TrendingUp as TrendingUpIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Lightbulb as LightbulbIcon,
} from '@mui/icons-material';

export const TYPE_CONFIG: Record<string, { icon: React.ReactElement; color: string; label: string }> = {
  opportunity: { icon: <TrendingUpIcon />, color: '#1976d2', label: 'Opportunity' },
  warning:     { icon: <WarningIcon />,    color: '#ed6c02', label: 'Warning'     },
  success:     { icon: <CheckCircleIcon />, color: '#2e7d32', label: 'Success'    },
  insight:     { icon: <LightbulbIcon />,  color: '#9c27b0', label: 'Insight'    },
};

export const IMPACT_COLORS: Record<string, 'error' | 'warning' | 'default'> = {
  High:   'error',
  Medium: 'warning',
  Low:    'default',
};
